<script lang="ts" setup>
  import { cva } from 'class-variance-authority'

  const props = withDefaults(
    defineProps<{
      hasExpandableRows: boolean
      modelValue: boolean
      switchId?: string
      inline?: boolean
    }>(),
    {
      switchId: undefined,
      inline: false
    }
  )

  const fallbackSwitchId = `fare-table-expand-all-${useId()}`
  const switchControlId = computed(() => props.switchId || fallbackSwitchId)

  const inlineClasses = computed(() =>
    cva('flex items-center gap-2 text-bt-blue-dark', {
      variants: {
        inline: {
          true: 'justify-start text-subtitle-2',
          false: 'w-full flex-row justify-between'
        }
      }
    })({
      inline: props.inline
    })
  )

  const switchLabelId = computed(() => `${switchControlId.value}-label`)

  const emits = defineEmits<{
    'update:modelValue': [value: boolean]
  }>()
</script>

<template>
  <div
    v-if="hasExpandableRows"
    class="flex items-center gap-2"
  >
    <div :class="inlineClasses">
      <UiSwitch
        v-if="inline"
        :id="switchControlId"
        :labelled-by="switchLabelId"
        :model-value="modelValue"
        @update:model-value="emits('update:modelValue', $event ?? false)"
      />
      <label
        :id="switchLabelId"
        :for="switchControlId"
      >
        {{ $t('fareTable.expandAll') }}
      </label>
      <UiSwitch
        v-if="!inline"
        :id="switchControlId"
        :labelled-by="switchLabelId"
        :model-value="modelValue"
        @update:model-value="emits('update:modelValue', $event ?? false)"
      />
    </div>
  </div>
</template>
